@if (vm().periods; as periods) {
    @if (vm().points; as points) {
        <div class="mybets-scoreboard_stats">
            <div class="mybets-scoreboard_stats-values mybets-scoreboard_stats-values-set">
                <div
                    class="mybets-scoreboard_stats-column basket-ball mybets-scoreboard_stats-column-points"
                    [ngStyle]="{ display: points.isVisible && points.isEnabled ? 'flex' : 'none' }"
                    [ngClass]="points.statClasses">
                    @if (points.isVisible && points.isEnabled) {
                        <div class="cell highlight">{{ points.player1 }}</div>
                        <div class="cell highlight">{{ points.player2 }}</div>
                        <div class="cell">
                            <vn-icon size="14" [name]="points.icon" />
                        </div>
                    }
                </div>
                @for (stat of periods.list; track $index) {
                    <div class="mybets-scoreboard_stats-column basket-ball mybets-scoreboard_stats-column-set" [class]="stat.statClasses">
                        @if (stat.isVisible) {
                            <div class="cell" [class]="stat.statClasses">{{ stat.player1 }}</div>
                            <div class="cell" [class]="stat.statClasses">{{ stat.player2 }}</div>
                            <div class="cell"></div>
                        }
                    </div>
                }
            </div>
        </div>
    }
}
